import { steps as editorFirstVisitSteps, tourId as editorFirstVisitTourId } from "./editor-first-visit";
export const tours = {
  [editorFirstVisitTourId]: editorFirstVisitSteps,
};
